import { cva, cx, type VariantProps } from '@/cva.config';
import { scoreTier } from '@/lib/score';

const scoreBadgeVariants = cva({
  base: [
    'flex shrink-0 items-center justify-center rounded-md border font-mono font-semibold tabular-nums',
  ],
  defaultVariants: { size: 'md' },
  variants: {
    size: {
      lg: 'size-14 text-sm lg:text-base',
      md: 'size-10 text-sm lg:text-base',
      sm: 'size-7 text-xs lg:text-sm',
    },
    tier: {
      high: 'border-score-high/30 bg-score-high/15 text-score-high',
      low: 'border-score-low/30 bg-score-low/15 text-score-low',
      mid: 'border-score-mid/30 bg-score-mid/15 text-score-mid',
      none: 'border-border bg-border/40 text-foreground-muted',
    },
  },
});

interface ScoreBadgeProps extends VariantProps<typeof scoreBadgeVariants> {
  className?: string;
  score: number | null;
}

export const ScoreBadge = ({ score, size, className }: ScoreBadgeProps) => (
  <div
    className={cx(
      scoreBadgeVariants({ size, tier: scoreTier(score) }),
      className,
    )}
  >
    {score ?? '–'}
  </div>
);
